'use client';

import { useEffect } from 'react';
import { initScrollTracking, initTimeTracking } from '@/lib/analytics';

interface BlogEngagementTrackerProps {
  slug: string;
}

/**
 * Client-side engagement tracking for blog posts
 * Tracks scroll depth and time on page for GA4 analytics
 */
export default function BlogEngagementTracker({ slug }: BlogEngagementTrackerProps) {
  useEffect(() => {
    // Initialize scroll depth tracking
    const cleanupScroll = initScrollTracking();

    // Initialize time tracking for blog content
    const cleanupTime = initTimeTracking('blog', slug);

    // Cleanup on unmount
    return () => {
      cleanupScroll();
      cleanupTime();
    };
  }, [slug]);

  // This component doesn't render anything
  return null;
}
